module.exports = __webpack_public_path__ + "img/Ford-SRS-111921-DealerDraft-Lifestyle.15e30e97.jpeg";